import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { convertPlanTypeToFeatureFlagKey } from '@dtx-company/true-common/src/utils/featureFlags/convertPlanTypeToFeatureFlagKey'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

/**
 * Retrieve the uid of the prismic doc for the flowcode limit modal from Optimizely based on the planType
 * @param planType
 * @returns the uid of the prismic doc for given planType {@link https://app.optimizely.com/v2/projects/17283172040/features/25493100014/rules}
 */
export function useFlowcodeLimitModalDocId(planType: PlanType | undefined): string | undefined {
  const [enabled, planSettings] = useFlowFeature('flowcode_limit_upsell_modal')
  if (planType === undefined) return undefined

  const ffVariableKey = convertPlanTypeToFeatureFlagKey(planType)
  const prismicUid = planSettings[ffVariableKey] || undefined

  return enabled ? prismicUid : undefined
}
